import React, { useState, useEffect } from "react";
import * as S from "./ModalCreateReceiptStyle";
import { receiptService } from "../../Services/receiptService";
import { formatNumber } from "../ASSETS/assets";

export default function ModalCreateReceipt({ withdrawData, onClose }) {
  // Define a descrição inicial baseada se tem contrato ou não
  const initialDescription = withdrawData.withdraw.contractId
    ? `Comprovante de Saque #${withdrawData.withdraw.id}`
    : `Comprovante de Saque #${withdrawData.withdraw.id} - SAQUE DE INDICAÇÃO`;

  const [description, setDescription] = useState(initialDescription);
  const [file, setFile] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async () => {
    if (!file) {
      alert("Por favor, selecione um arquivo.");
      return;
    }

    setLoading(true);
    const formData = new FormData();
    formData.append("clientId", withdrawData.withdraw.clientId);
    formData.append("withdrawId", withdrawData.withdraw.id);

    // Lógica do Contrato Opcional
    if (withdrawData.withdraw.contractId) {
      formData.append("contractId", withdrawData.withdraw.contractId);
      formData.append("description", description);
    } else {
      // Envia 0 se não tiver contrato
      formData.append("contractId", 0);
      // Garante que a descrição tenha a tag se o usuário apagou acidentalmente (opcional, mas bom)
      // Mas como já iniciamos com ela, vamos mandar o que o usuário escreveu.
      formData.append("description", description);
    }

    formData.append("file", file);

    try {
      await receiptService.createWithdrawReceipt(formData);
      alert("Recibo anexado com sucesso!");
      onClose();
    } catch (error) {
      console.error(error);
      alert(
        "Erro ao criar recibo: " +
          (error.response?.data?.message || "Erro desconhecido")
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <S.Overlay>
      <S.Container>
        <S.Header>
          <h3>Anexar Recibo</h3>
          <button onClick={onClose}>&times;</button>
        </S.Header>

        <S.InfoBox>
          <p>
            <strong>Cliente:</strong> {withdrawData.clientName}
          </p>
          <p>
            <strong>Saque ID:</strong> #{withdrawData.withdraw.id}
          </p>
          <p>
            <strong>Contrato ID:</strong> #
            {withdrawData.withdraw.contractId || "N/A (Indicação)"}
          </p>
          <p>
            <strong>Valor:</strong> R${" "}
            {formatNumber(withdrawData.withdraw.amountWithdrawn)}
          </p>
        </S.InfoBox>

        <S.FormGroup>
          <label>Descrição</label>
          <textarea
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            placeholder="Descrição do comprovante..."
          />
        </S.FormGroup>

        <S.FormGroup>
          <label>Arquivo (Imagem/PDF)</label>
          <input
            type="file"
            accept="image/*,.pdf"
            onChange={(e) => setFile(e.target.files[0])}
          />
        </S.FormGroup>

        <S.SubmitButton onClick={handleSubmit} disabled={loading}>
          {loading ? "Enviando..." : "Confirmar e Anexar"}
        </S.SubmitButton>
      </S.Container>
    </S.Overlay>
  );
}
